import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const TableList = lazy(() => import('../Pages/RestaurantTableList'));
const EditRestaurantTable = lazy(() => import('../Pages/EditRestaurantTable'));
const AddRestaurantTable = lazy(() => import('../Pages/AddRestaurantTable'));
const RestaurantTableView = lazy(() => import('../Pages/RestaurantTableView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined;

function RestaurantTableRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/restaurant/tables"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <TableList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/restaurant/tables/list"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <TableList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/restaurant/tables/add"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <AddRestaurantTable history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/restaurant/tables/edit/:slack"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <EditRestaurantTable history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/restaurant/tables/view/:slack"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <RestaurantTableView history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </Switch>
    );
};

export default RestaurantTableRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
